export default __webpack_public_path__ + "static/media/arena_19.6fe884d4.jpeg";